import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_ACC006_Request,
  IAPI_ACC006_Response,
} from "../../../type/apiType";

// パスワード再発行メール送信
const httpAPI_ACC006 = async (
  param: IAPI_ACC006_Request
): Promise<IAPI_ACC006_Response> => {
  let res = await http.post(ApiUrl.API_ACC006, {
    ...param,
  });
  return res.data;
};

export { httpAPI_ACC006 };
